import request from '@/utils/request'

// 查询公告列表分页
export function pageNotice (query) {
  return request({
    url: '/system/notices/page',
    method: 'get',
    params: query
  })
}
// 查询公告列表
export function listNotice (query) {
  return request({
    url: '/system/notices/list',
    method: 'get',
    params: query
  })
}
// 查询公告详细
export function getNotice (noticeId) {
  return request({
    url: '/system/notices/' + noticeId,
    method: 'get'
  })
}

// 新增公告
export function addNotice (data) {
  return request({
    url: '/system/notices/add',
    method: 'get',
    params: data
  })
}

// 修改公告
export function updateNotice (data) {
  return request({
    url: '/system/notices/edit',
    method: 'get',
    params: data
  })
}

// 删除公告
export function delNotice (noticeId) {
  return request({
    url: '/system/notices/' + noticeId,
    method: 'delete'
  })
}
